import { debounce } from 'lodash';
import {
  api, checkForUnauthorized, roles, getRoleText,
} from '@/utils';

export default {
  name: 'StakeholderOverviewTable',
  components: {},
  props: {
    search: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    headers: [
      { text: 'Code', value: 'id' },
      { text: 'Name', value: 'name' },
      { text: 'NxtEntityId', value: 'nxtEntityId' },
      { text: 'Vat', value: 'vat' },
      { text: 'ApicsCode', value: 'apicsCode' },
      { text: 'Roles', value: 'roles' },
      { text: '', value: 'buttons' },
    ],
    stakeholders: [],
    loading: true,
    pageSize: 10,
    page: 1,
    apiVersion: 1,
    showConfirm: false,
    itemIdToDelete: '',
    roles,
  }),
  computed: {},
  methods: {
    fetchStakeholders() {
      this.loading = true;

      // BASEURL
      let url = '/stakeholders?';

      url += `page=${this.page}&page-size=${this.pageSize}`;

      if (this.search !== '') {
        url += `&name=${this.search}`;
      }

      api.get(url)
        .then((response) => {
          if (response.data.length <= 0) {
            this.$eventHub.$emit('show-snackbar', 'No (more) stakeholders found.');
          } else {
            this.stakeholders = [...this.stakeholders, ...response.data];
          }
          this.loading = false;
        })
        .catch((error) => {
          checkForUnauthorized(error);
          console.log('something went wrong while getting the stakeholders', error);
        });
    },
    goToDetail(item) {
      this.$router.push({ name: 'stakeholder-with-id', params: { id: item.id } });
    },
    fetchMoreStakeholders() {
      this.page += 1;
      this.fetchStakeholders();
    },
    debounceSearch: debounce(function fetchStakeholders() {
      this.page = 1;
      this.stakeholders = [];
      this.fetchStakeholders();
    }, 300),
    getRoleText(selectedRoles) {
      return getRoleText(selectedRoles);
    },
  },
  watch: {
    search() {
      this.debounceSearch();
    },
  },
  mounted() {
    this.fetchStakeholders();
  },
};
